// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-o_fA","advertDetailContactItem__link":"c-o_fB"};